// extracted by mini-css-extract-plugin
module.exports = {"Loader_img":"Loader_Loader_img__rGH7y","Loader_img_spin":"Loader_Loader_img_spin__1iyJe","spin":"Loader_spin__3E4o4","Loader_txt":"Loader_Loader_txt__3kWZL"};